import React from 'react'
import RechargePay from '../components/RechargePay'

import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

const Recharge = () => {
  return (
    <>
      <Navbar />
      <RechargePay />
      <Footer />
    </>
  )
}

export default Recharge
